import React from "react";
import { Provider } from "react-redux";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ShoppingCartProvider } from "./components/_default/context/ShoppingCartContext"
import store from "./store/store"
import Redirect from "./components/_default/utilities/Redirect"
import TagManager from 'react-gtm-module'
// Pages
import Webpage6Kardis__idu_broneerimine from "./pages/Webpage6Kardis__idu_broneerimine";
import Webpage7Tellimus from "./pages/Webpage7Tellimus";
import Webpage8Lehte_ei_leitud from "./pages/Webpage8Lehte_ei_leitud";

var baseURL = 'https://laitserallypark.kassahaldus.ee/webstoreApi';
var axiosHeaders = {
    Authorization: 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiI3IiwianRpIjoiMzJjN2U1NGNjOTZiNDQwMDJmZGVkNGEwYmUwMzJhYWFmMjAzOGUwZWM1ZjdhOGJlN2QzZmY3ZTY4NTJhOTcxZTY0NWMzMTkwZDMzMzRhZjUiLCJpYXQiOjE3ODQ0Mzk2NTIuNDE5NDQ1LCJuYmYiOjE3ODQ0Mzk2NTIuNDE5NDQ5LCJleHAiOjE3ODQ1MjYwNTIuNDE2NTQxLCJzdWIiOiI4Iiwic2NvcGVzIjpbXX0.vw3pE36VttPfJSKwThIQSAf-Ze5Ym9FKxgxkt61jKDWjI8GSCLnL0GZ6lNHqj45YNERp-Ih6FwHfButWcttu5uy0WSAmq47o8Vz1IaMdItPab3AGgEuryfWRPCDIS8CNxL5dGccyN7lVFz83LmT69Q6RBhL3UCreI3SfUaIAbmijKyIX3ChWbea9XP6PL1_wPiSvJK8cF0VuP8LvAqTnQ9Geg9-F7ywf6GZc0yGdektagj74UPCq8eiRYZyyFmYs8IeESr0KKqTG_JqBO6WlflKcdm43l2tr_QT2StpI0Box6PkEEQj8j-RiNzJxsh7JvucE2KnJxY0dXquPXAS6PlpGNC1jq_8benOrs0VLE_t9D3EGlcseCcTtSmDjSxfxuCZIb0zRLEFSd7PCYqbfpPN7QlxDy7gSRuA4br3jOvSTcdQx8tDPLmKnuU0J4hpcT8w5-LfZMrLow4kluJ7C-XsO1-WnvG7ZGt4oKb2hKw_AW-virx0noUFUFeTiorhSm4SUjeXCNUynYsyrMIYPy_2s-sjbe009Xv8ZznypkmwnQgUcuhm7-NILwi2iZHr2k3UF10l0fAhxoPgStu_xTZhFSb03fWWG_FcYbvfQWz1R1EHMuOJVyGA6ycq5vIlNiVEsJk6fjWWZ3zswtpmkMV3EI-LtApKLFI8khASntyU',
    'Access-api-key': "eyJpdiI6IkdDbDNLZUcyTTJEaFM1a0czR1FoZWc9PSIsInZhbHVlIjoiVW5hZzJXMnlPVk80cm1lczlEbmZXZz09IiwibWFjIjoiNzg4OTAxOTZlMmE4NjFhOTAwNmExMmMwMmU5NGNhZTYwNjM5NGJkZjhjNjhmYmQ0ZTEwMzNmMThlNzk5MGQ2YyIsInRhZyI6IiJ9",
    'Access-api-id': "eyJpdiI6IjV3RGNwZ092NjlDbzQrZmQrempXV1E9PSIsInZhbHVlIjoiSXZxWXJuUGZMZU1mWVR0djVzK0s0Zz09IiwibWFjIjoiMzNjMDNiMGJkNTMyYWEyNTQ3NzFhNjI2MmUwMjNhZjIzZDc3NmVlNzAyMTU5YzEwNzk4YjUzMTg4ODExMTY1YyIsInRhZyI6IiJ9",
    'Access-Control-Allow-Origin': "*"
 };


window.axios = require('axios').create({
  baseURL: baseURL,
  headers: axiosHeaders
});
const tagManagerArgs = {
    gtmId: ""
}
TagManager.initialize(tagManagerArgs)
    
export default function App() {
    window.dataLayer.push({
        event: 'pageview'
    });
    return (
        <Provider store={store}>
            <ShoppingCartProvider>
                <BrowserRouter basename="/">
                    <Routes>
                                            <Route path="/et/" element={<Webpage6Kardis__idu_broneerimine />} exact />;
                                                                    <Route path="/et/tellimus" element={<Webpage7Tellimus />} exact />;
                                                                    <Route path="/et/*" element={<Webpage8Lehte_ei_leitud />} exact />;
                                                <Route path="*" element={<Webpage8Lehte_ei_leitud />} exact />;
                                                                
                                                            </Routes>
                </BrowserRouter>
            </ShoppingCartProvider>
        </Provider>
    );
}